import React from 'react';
import Dialog from 'sushiweb/Dialog';

const RemoveDDModal = ({
  openRemoveDiallersDialog,
  setOpenRemoveDiallersDialog,
  removeDiallers,
  selectedOrg = {},
}) => {
  return (
    <Dialog
      visible={openRemoveDiallersDialog}
      acceptLabel={
        <span className='tw-font-medium'>
          Reset Delay Diallers for {selectedOrg?.name}
        </span>
      }
      rejectLabel={<span className='tw-font-medium'>Cancel</span>}
      onAccept={removeDiallers}
      onReject={() => setOpenRemoveDiallersDialog(false)}
    >
      <p className='tw-font-medium'>
        Remove current delay diallers and reset to default?
      </p>
    </Dialog>
  );
};

export default RemoveDDModal;
